import { StarsButton, Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';

import { select } from '@swf/core/store';
import { useCheckUserClubRole, useHomeGamesWidget } from '@swf/poker';

import { HGToastType, UserClubRole } from '../../types/common';
import ToastMessage from '../ToastMessage/ToastMessage';

import {
  TXTWCL_Great_newsX_you_have_the_optio_ELL,
  TXTWCL_Make_it_public
} from './MakeClubPublicToast.messages.json';
import styles from './MakeClubPublicToast.scss';
import IconEarth from './assets/icon-earth.svg';

const MakeClubPublicToast: React.FC = () => {
  const { homegames } = useSelector(select.localSettings.get);
  const { widgetSelect } = useHomeGamesWidget();
  const { clubId } = useParams<{ clubId: string }>();
  const isManager = useCheckUserClubRole(clubId, [UserClubRole.Manager]);
  const pathname = `/homegames/clubs/${clubId}/settings/`;
  const clubOptionsById = useSelector(widgetSelect.clubOptionsById);
  const isOpenClub = clubOptionsById[clubId]?.open;

  const isHiddenToastMessage = homegames?.toastMessage?.[HGToastType.MakeClubPublicToast]?.isHidden;

  return isManager && !isOpenClub && !isHiddenToastMessage ? (
    <ToastMessage id={HGToastType.MakeClubPublicToast}>
      <div className={styles.iconContainer}>
        <IconEarth width="40" height="40" />
      </div>
      <div className={styles.toastText}>
        <Translation tagName="p" {...TXTWCL_Great_newsX_you_have_the_optio_ELL} />
      </div>
      <div className={styles.buttonContainer}>
        <StarsButton
          className={classNames(styles.publicButton, styles.btnBorder)}
          block
          variant="casino"
          href={pathname}
          translation={TXTWCL_Make_it_public}
        />
      </div>
    </ToastMessage>
  ) : null;
};

export default MakeClubPublicToast;
